

function initMasthead() {
  const masthead = document.querySelector( '.masthead' );
  const submenus = document.querySelectorAll( '.main-menu .menu__submenu' );
  const menuOverlay = document.querySelector( '.menu-overlay' );
  const mastheadHeight = getComputedStyle( document.documentElement ).getPropertyValue( '--header-height' ).replace( 'px', '' );
  let lastScrollTop = 0;

  if (masthead && window.innerWidth > 1200) {
    window.addEventListener( 'scroll', (event) => {
      let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScrollTop > lastScrollTop && currentScrollTop > mastheadHeight) {
        masthead.classList.add( 'hide' );
        masthead.classList.remove( 'menu-open' );
        masthead.classList.add( 'opaque' );
      } else {
        masthead.classList.remove( 'hide' );
      }

      if (currentScrollTop === 0) {
        masthead.classList.remove( 'opaque' );
      }

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    } );
  }
}

export default {
  init() {
    initMasthead();
  },
};